import React from "react";
import { connect } from "react-redux";
import { Form, Button, Modal, Row, Col } from "react-bootstrap";
import { DateRange } from "@material-ui/icons";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import moment from "moment";
import DatePicker from "react-datepicker";
import * as message from "./../../../config/CommonMessages";
import {
  getbillingPlans,
  deleteNewPlan,
  updatCurrentPlanEndDate,
} from "./../../../actions/BillingActions";
import { myProfileAction } from "./../../../actions/UserActions";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

/**
 * @desc created pure component for open delete prompt
 */
class AssignPlanForm extends React.Component {
  constructor(props) {
    super(props);

    this.minsDate = moment().format("YYYY-MM-DD");

    this.state = {
      showLoader: true,
      billingPlan: [],
      selectedPlanId: "",
      startDate: new Date(),
      endDate: new Date(),
      errors: {},
      currentPlanName: "",
      currentPlanStartDate: "",
      currentPlanEndDate: "",
      showConfarmationflag: false,
      render: false,
      editCurrentPlan: false,
      currentPlanId: "",
      updatedEnddate: "",
    };
  }

  componentWillMount() {
    this.getallBillingplan();
    if (this.props.flag === "changePlan") {
      // console.log("here changePlan", this.props.userId);
      this.getPlanDetails(this.props.userId);
    }
  }

  getPlanDetails(id) {
    this.props.myProfileAction(id).then((res) => {
      if (this.props.profileData && this.props.profileData.billingUserData) {
        if (this.props.profileData.billingUserData.currentPlanId) {
          // let sDate = this.props.profileData.billingUserData
          //   .currentPlanStartDate;
          // let eDate = this.props.profileData.billingUserData.currentPlanEndDate;
          // this.setState({
          //   selectedPlanId: this.props.profileData.billingUserData
          //     .currentPlanId,
          //   startDate: new Date(sDate),
          //   endDate: new Date(eDate),
          // });
          let endDate = new Date(
            this.props.profileData.billingUserData.currentPlanEndDate
          );
          endDate.setUTCHours(0, 0, 0, 0);
          this.setState({
            currentPlanId: this.props.profileData.billingUserData.currentPlanId,
            currentPlanName: this.props.profileData.billingUserData.PlanName,
            currentPlanStartDate: moment(
              this.props.profileData.billingUserData.currentPlanStartDate
            ).format("MM/DD/YYYY"),
            // currentPlanEndDate: moment(
            //   this.props.profileData.billingUserData.currentPlanEndDate
            // ).format("MM/DD/YYYY"),
            currentPlanEndDate: moment(endDate).format("MM/DD/YYYY"),
          });
          if (this.props.profileData.billingUserData.newPlan) {
            let newPlanEnddate = new Date(
              this.props.profileData.billingUserData.newPlan.newPlanEndDate
            );
            newPlanEnddate.setUTCHours(0, 0, 0, 0);

            this.setState({
              nextPlanName: this.props.profileData.billingUserData.newPlanname,
              nextPlanStartDate: moment(
                this.props.profileData.billingUserData.newPlan.newPlanStartDate
              ).format("MM/DD/YYYY"),
              // nextPlanEndDate: moment(
              //   this.props.profileData.billingUserData.newPlan.newPlanEndDate
              // ).format("MM/DD/YYYY"),
              nextPlanEndDate: moment(newPlanEnddate).format("MM/DD/YYYY"),
            });
          }
        }
      }
    });
  }

  getallBillingplan() {
    this.setState({
      showLoader: true,
    });
    this.props.getbillingPlans().then((result) => {
      this.setState({
        billingPlan:
          Array.isArray(result.data) && result.data.length > 0
            ? result.data.filter((item) => item.isActive === true)
            : [],
        showLoader: false,
      });
    });
  }

  findFormErrors() {
    const newErrors = {};
    if (!this.state.selectedPlanId || this.state.selectedPlanId === "") {
      newErrors.plan = message.SELECT_BILLING_PLAN;
    }
    //date errors
    var mStart = moment(this.state.startDate);
    var mEnd = moment(this.state.endDate);
    if (!mStart.isBefore(mEnd)) {
      newErrors.endDate = message.END_DATE_INVALID;
    }
    // if (Object.keys(newErrors).length > 0) {
    //   console.log('here if err ');
    //   // We got errors!
    //   this.setState({ errors: newErrors });
    // } else {
    //   this.setState({ errors: {} });
    // }
    return newErrors;
  }

  onSubmit() {
    const newErrors = this.findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      // We got errors!
      this.setState({ errors: newErrors });
    } else {
      this.setState({ errors: {} });
      let formattedstartDate = moment(this.state.startDate).format(
        "YYYY-MM-DD"
      );
      let formattedEndDate = moment(this.state.endDate).format("YYYY-MM-DD");
      let postData = {
        selectedPlanId: this.state.selectedPlanId,
        startDate: formattedstartDate,
        endDate: formattedEndDate,
      };
      this.props.assignPlan(postData);
    }
  }

  showConfarmation = () => {
    this.setState({ showConfarmationflag: true });
  };

  closeConfarmation = () => {
    this.setState({ showConfarmationflag: false });
  };

  deleteNewplan = () => {
    let data = { userId: this.props.userId };
    this.props.deleteNewPlan(data).then((result) => {
      if (result.status === 200) {
        this.closeConfarmation();
        this.props.cancel();
      }
    });
  };

  handleEdit = () => {
    this.setState({
      editCurrentPlan: true,
      updatedEnddate: this.state.currentPlanEndDate,
    });
  };

  updateEnddateOfCurrentPlan = () => {
    // let endDate = new Date(this.state.updatedEnddate);
    // const utcEndDateString = endDate.toISOString();
    // const encodedEndDate = encodeURIComponent(utcEndDateString);

    const enddate = moment(this.state.updatedEnddate).format("YYYY-MM-DD");
    // console.log("enddate", enddate);
    let data = {
      endDateforupdate: enddate,
      userId: this.props.userId,
    };
    // console.log("data-175", data);
    this.props.updatCurrentPlanEndDate(data).then((result) => {
      if (result.status === 200) {
        // console.log("result-174", result);
        this.closeEditcurrentPlanPopup();
        this.props.cancel();
      }
    });
  };

  closeEditcurrentPlanPopup = () => {
    this.setState({
      editCurrentPlan: false,
    });
  };

  render() {
    return (
      <>
        <Modal
          show={this.props.billingPlanPrompt}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400"
          backdrop={false}
        >
          <Modal.Header>
            <Modal.Title id="example-custom-modal-styling-title">
              {this.props.flag === "changePlan"
                ? "Change Plan"
                : "Add Plan & Activate"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-0">
            {this.props.flag === "changePlan" && (
              <>
                <div
                  className="font-16 mb-2"
                  style={{ textDecoration: "underline" }}
                >
                  Current Plan Details
                </div>
                <Row className="mb-4">
                  <Col xs={12} sm={4}>
                    <div className="font-12 color-grey-1 font-500">
                      Plan Name
                    </div>
                    <div className="font-12 mb-2">
                      {this.state.currentPlanName
                        ? this.state.currentPlanName
                        : "-"}
                    </div>
                  </Col>

                  <Col xs={12} sm={4}>
                    <div className="font-12 color-grey-1 font-500">
                      Plan Start Date
                    </div>

                    <div className="font-12 color-grey-1 font-500">
                      {this.state.currentPlanStartDate
                        ? this.state.currentPlanStartDate
                        : "-"}
                    </div>
                  </Col>
                  <Col xs={12} sm={4}>
                    <div className="font-12 color-grey-1 font-500">
                      Plan End Date
                    </div>
                    <div className="font-12 color-grey-1 font-500">
                      {this.state.currentPlanEndDate
                        ? this.state.currentPlanEndDate
                        : "-"}
                      <EditIcon
                        style={{
                          maringLeft: "15px",
                          height: "20px",
                          widt: "20px",
                        }}
                        onClick={() => {
                          this.handleEdit();
                        }}
                      />
                    </div>
                  </Col>
                  {/* <Col xs={12} sm={3}>
                    
                  </Col> */}
                </Row>
                {this.state.nextPlanName && (
                  <div
                    className="font-16 mb-2"
                    style={{ textDecoration: "underline", fontWeight: 600 }}
                  >
                    Next Plan Details{" "}
                    <DeleteIcon
                      style={{
                        height: "20px",
                        width: "20px",
                        marginTop: "-5px",
                      }}
                      onClick={() => {
                        this.showConfarmation();
                      }}
                    />
                  </div>
                )}
                {this.state.nextPlanName && (
                  <Row className="mb-4">
                    <Col xs={12} sm={4}>
                      <div className="font-12 color-grey-1 font-500">
                        Plan Name
                      </div>
                      <div className="font-12 mb-2">
                        {this.state.nextPlanName
                          ? this.state.nextPlanName
                          : "-"}
                      </div>
                    </Col>

                    <Col xs={12} sm={4}>
                      <div className="font-12 color-grey-1 font-500">
                        Plan Start Date
                      </div>

                      <div className="font-12 color-grey-1 font-500">
                        {this.state.nextPlanStartDate
                          ? this.state.nextPlanStartDate
                          : "-"}
                      </div>
                    </Col>
                    <Col xs={12} sm={4}>
                      <div className="font-12 color-grey-1 font-500">
                        Plan End Date
                      </div>
                      <div className="font-12 color-grey-1 font-500">
                        {this.state.nextPlanEndDate
                          ? this.state.nextPlanEndDate
                          : "-"}
                      </div>
                    </Col>
                    {/* <Col xs={12} sm={3}>
                      
                    </Col> */}
                  </Row>
                )}
              </>
            )}
            <div className="form-group">
              <Form.Group>
                <Form.Label>
                  {this.props.flag === "changePlan" ? "New " : ""}Plan
                  <span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  as="select"
                  name="plan"
                  onChange={(e) => {
                    this.setState({ selectedPlanId: e.target.value });
                    //this.findFormErrors();
                  }}
                  value={this.state.selectedPlanId}
                  isInvalid={!!this.state.errors.plan}
                >
                  <option value="">Select</option>

                  {this.state.billingPlan &&
                    this.state.billingPlan.map((plan) => {
                      return (
                        <option key={plan._id} value={plan._id}>
                          {plan.PlanName}
                        </option>
                      );
                    })}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {this.state.errors.plan}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group>
                <Form.Label>
                  {this.props.flag === "changePlan" ? "New " : ""}Plan Start
                  Date
                  <span className="text-danger"> *</span>
                </Form.Label>
                <div style={{ width: "100%" }}>
                  <DatePicker
                    onChange={(date) => {
                      this.setState({ startDate: date });
                    }}
                    name="startDate"
                    className="form-control form-control-sm pl-1 date-picker"
                    dateFormat="MM-d-yyyy"
                    selected={this.state.startDate}
                    minDate={new Date(this.minsDate)}
                  />
                </div>
              </Form.Group>
              <Form.Group>
                <Form.Label>
                  {this.props.flag === "changePlan" ? "New " : ""}Plan End Date
                  <span className="text-danger"> *</span>
                </Form.Label>
                <div style={{ width: "100%" }}>
                  <DatePicker
                    onChange={(date) => {
                      this.setState({ endDate: date });
                    }}
                    name="endDate"
                    className="form-control form-control-sm pl-1 date-picker"
                    dateFormat="MM-d-yyyy"
                    selected={this.state.endDate}
                    minDate={new Date(this.minsDate)}
                  />
                </div>
                {this.state.errors && this.state.errors.endDate && (
                  <Form.Text className="custom-error-msg">
                    {this.state.errors.endDate}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.onSubmit();
              }}
              // disabled={this.state.selectedPlan.trim() == ""}
            >
              Submit
            </Button>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.setState({
                  selectedPlanId: "",
                  startDate: new Date(),
                  endDate: new Date(),
                  errors: {},
                });
                this.props.cancel();
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showConfarmationflag}
          dialogClassName="modal-90w"
          onHide={() => this.closeConfarmation()}
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400"
          backdrop={false}
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
              Delete Plan
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-0">
            <div>Are you sure want to delete ?</div>
          </Modal.Body>
          <Modal.Footer>
            <Row className="mb-4">
              <Col xs={12} sm={6}>
                <Button
                  variant="primary"
                  className="btn-blue btn-outlined w-140"
                  onClick={() => {
                    this.deleteNewplan();
                  }}
                >
                  Yes
                </Button>
              </Col>
              <Col xs={12} sm={6}>
                <Button
                  variant="primary"
                  className="btn-blue btn-outlined w-140"
                  onClick={() => {
                    this.closeConfarmation();
                  }}
                >
                  No
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.editCurrentPlan}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          className="modal-med modal-400"
          backdrop={false}
        >
          <Modal.Header>
            <Modal.Title id="example-custom-modal-styling-title">
              {"Update Current Plan"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="pb-0">
            <div className="form-group">
              <Form.Group>
                <Form.Label>
                  {"Update Current Plan"}
                  <span className="text-danger"> *</span>
                </Form.Label>
                <Form.Control
                  as="select"
                  name="plan"
                  value={this.state.currentPlanId}
                  disabled={true}
                >
                  <option value="">Select</option>
                  {this.state.billingPlan &&
                    this.state.billingPlan.map((plan) => {
                      return (
                        <option key={plan._id} value={plan._id}>
                          {plan.PlanName}
                        </option>
                      );
                    })}
                </Form.Control>
              </Form.Group>
              <Form.Group>
                <Form.Label>
                  {this.props.flag === "changePlan" ? "New " : ""}Plan Start
                  Date
                  <span className="text-danger"> *</span>
                </Form.Label>
                <div style={{ width: "100%" }}>
                  <DatePicker
                    name="startDate"
                    className="form-control form-control-sm pl-1 date-picker"
                    dateFormat="MM-d-yyyy"
                    selected={new Date(this.state.currentPlanStartDate)}
                    minDate={new Date(this.minsDate)}
                    disabled={true}
                  />
                </div>
              </Form.Group>
              <Form.Group>
                <Form.Label>
                  {this.props.flag === "changePlan" ? "New " : ""}Plan End Date
                  <span className="text-danger"> *</span>
                </Form.Label>
                <div style={{ width: "100%" }}>
                  <DatePicker
                    onChange={(date) => {
                      this.setState({ updatedEnddate: date });
                    }}
                    name="endDate"
                    className="form-control form-control-sm pl-1 date-picker"
                    dateFormat="MM-d-yyyy"
                    selected={new Date(this.state.updatedEnddate)}
                    minDate={new Date(this.minsDate)}
                  />
                </div>
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="btn-blue w-140"
              onClick={() => {
                this.updateEnddateOfCurrentPlan();
              }}
            >
              Update
            </Button>
            <Button
              variant="primary"
              className="btn-blue btn-outlined w-140"
              onClick={() => {
                this.closeEditcurrentPlanPopup();
              }}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return { profileData: state.reducer.profileData };
};
export default connect(mapStateToProps, {
  getbillingPlans,
  myProfileAction,
  deleteNewPlan,
  updatCurrentPlanEndDate,
})(AssignPlanForm);
